// src/tools/RectangleToolHandler.js

import layerLibrary from '../canvas/LayerLibrary';
import layoutEngine from '../libraries/layoutEngine';
import InstanceLibrary, { hexToRgba } from '../libraries/RectangleLibrary';
import ProjectManager from './ProjectManager';
export default class RectangleToolHandler {
  constructor(engine) {
    this.engine = engine;
    this.moveMode = false;
this.moveStart = null;
this.originalPositions = [];
this.isMultiMoveMode = false;

  }

   snapToGrid(value, axis = 'x') {
    // Delegate to CanvasEngine → GridSystem so 0.01 (ya jo bhi) drawing step respect ho
    return this.engine.snapToGrid(value, axis);
  }
  
  

  handleMouseDown(e) {
    const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
    const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;
    this.engine.isDrawing = true;
    this.engine.drawStart = { x, y };
    this.engine.isPanning = false;
    
      
  }

  handleMouseMove(e) {
  const endX = (e.offsetX - this.engine.offsetX) / this.engine.scale;
  const endY = (e.offsetY - this.engine.offsetY) / this.engine.scale;

  const x = Math.min(this.engine.drawStart.x, endX);
  const y = Math.max(this.engine.drawStart.y, endY); // Changed to MAX for bottom-left origin
  const width = Math.abs(endX - this.engine.drawStart.x);
  const height = Math.abs(endY - this.engine.drawStart.y);

  this.engine.previewRect = {
    x: this.snapToGrid(x),
    y: this.snapToGrid(y - height), // Adjusted for bottom-left origin
    width: this.snapToGrid(width),
    height: this.snapToGrid(height),
  };
  this.engine.draw();
}

  handleMouseUp() {
    if (this.engine.pastingInProgress) return;

    if (!this.engine.previewRect) return;
    const { x, y, width, height } = this.engine.previewRect;

    // shiv code
      const minSize = 1; // Minimum allowed size (1px)
  if (Math.abs(width) < minSize || Math.abs(height) < minSize) {
    console.log("❌ Ignored invalid rectangle (line or too small)");
    this.engine.previewRect = null;
    this.engine.isDrawing = false;
    this.engine.drawStart = null;
    this.engine.draw();  // Redraw to clear preview
    return;
  }
  //end shiv code

    const snappedX = this.snapToGrid(x);
    const snappedY = this.snapToGrid(y);
    const snappedW = this.snapToGrid(width);
    const snappedH = this.snapToGrid(height);

    const activeLayerId = layerLibrary.getSelectedLayerId();
    const layer = layerLibrary.getLayerById(activeLayerId);
    if (!layer) return alert("⚠️ Please select a valid layer before drawing.");

    const cellName = ProjectManager.getSelectedCell(); // 🧠 active cell
    const layerNum  = String(layer.layer_number ?? 1);
    const dtypeNum  = String(layer.datatype_number ?? 0);
    const layerId   = `${layerNum}:${dtypeNum}`;

    // ✅ Route: if in uploaded mode AND cell exists in uploadedCells → push there directly
    const uploadedCell = this.engine.useUploadedCells
      ? layoutEngine.getUploadedCell(cellName)
      : null;

    if (uploadedCell) {
      // Duplicate guard: same position + same layer
      const isDuplicate = uploadedCell.elements.some(el =>
        el.type === 'rectangle' &&
        el.x === snappedX && el.y === snappedY &&
        el.width === snappedW && el.height === snappedH &&
        el.layerId === layerId
      );
      if (!isDuplicate) {
        uploadedCell.elements.push({
          id: crypto.randomUUID(),
          type: 'rectangle',
          x: snappedX,
          y: snappedY,
          width: snappedW,
          height: snappedH,
          layerId,
          layer: layerNum,
          datatype: dtypeNum,
          layerNumber: layerNum,
          datatypeNumber: dtypeNum,
          layerName: layer.layer_name,
          color: layer.color,
          fill: layer.color,
          stroke: layer.color,
          opacity: layer?.pattern?.opacity ?? 1,
          selected: false,
          visible: true,
        });
      }
    } else {
      // 🟢 Created cell path — original behavior unchanged
      InstanceLibrary.addRectangle(cellName, activeLayerId, snappedX, snappedY, snappedW, snappedH, {
        color: layer.color,
        fill: layer.color,
        stroke: layer.color,
        layerNumber: layer.layer_number,
        datatypeNumber: layer.datatype_number,
        layerName: layer.layer_name,
        opacity: layer?.pattern?.opacity ?? 1,
      });
    }

    this.engine.previewRect = null;
    this.engine.isDrawing = false;
    this.engine.drawStart = null;
    this.engine.draw();
  }


  handleMoveMouse(e) {
    if (!this.moveMode || !this.originalPositions.length) return;
    const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
    const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;
  
    if (!this.moveStart) {
      this.moveStart = { x, y };
      return;
    }
  
    const dx = this.snapToGrid(x - this.moveStart.x);
    const dy = this.snapToGrid(y - this.moveStart.y);
  
    this.engine.selectedRects.forEach((rect, i) => {
      rect.x = this.originalPositions[i].x + dx;
      rect.y = this.originalPositions[i].y + dy;
    });
  
    this.engine.draw();
  }



// === New Resize System ===
checkResizeCursor(e) {
  const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
  const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;

  this.resizeTarget = null;
  this.resizeEdge = null;

  for (let rect of this.engine.selectedRects) {
    const margin = 5 / this.engine.scale;  // 5px margin for easier edge hover
    const left = rect.x;
    const right = rect.x + rect.width;
    const top = rect.y;
    const bottom = rect.y + rect.height;

    if (this.isNear(x, left, margin) && this.isNear(y, top, margin)) {
      this.engine.canvas.style.cursor = "nwse-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "top-left";
      return;
    }
    if (this.isNear(x, right, margin) && this.isNear(y, top, margin)) {
      this.engine.canvas.style.cursor = "nesw-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "top-right";
      return;
    }
    if (this.isNear(x, left, margin) && this.isNear(y, bottom, margin)) {
      this.engine.canvas.style.cursor = "nesw-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "bottom-left";
      return;
    }
    if (this.isNear(x, right, margin) && this.isNear(y, bottom, margin)) {
      this.engine.canvas.style.cursor = "nwse-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "bottom-right";
      return;
    }
    if (this.isNear(x, left, margin) && y >= top && y <= bottom) {
      this.engine.canvas.style.cursor = "ew-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "left";
      return;
    }
    if (this.isNear(x, right, margin) && y >= top && y <= bottom) {
      this.engine.canvas.style.cursor = "ew-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "right";
      return;
    }
    if (this.isNear(y, top, margin) && x >= left && x <= right) {
      this.engine.canvas.style.cursor = "ns-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "top";
      return;
    }
    if (this.isNear(y, bottom, margin) && x >= left && x <= right) {
      this.engine.canvas.style.cursor = "ns-resize";
      this.resizeTarget = rect;
      this.resizeEdge = "bottom";
      return;
    }
  }

  this.engine.canvas.style.cursor = "default";
}

isNear(p1, p2, margin = 5) {
  return Math.abs(p1 - p2) <= margin;
}



startResize(e) {
  if (!this.resizeTarget || !this.resizeEdge) return false;

  const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
  const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;
  this.startResizePos = { x, y };
  this.startResizeRect = { ...this.resizeTarget };

  this.isResizing = true;
  return true;
}

performResize(e) {
  if (!this.isResizing || !this.resizeTarget) return;

  const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
  const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;

  const deltaX = this.snapToGrid(x - this.startResizePos.x);
  const deltaY = this.snapToGrid(y - this.startResizePos.y);

  if (this.resizeEdge === "left") {
    this.resizeTarget.x = this.startResizeRect.x + deltaX;
    this.resizeTarget.width = this.startResizeRect.width - deltaX;
  } else if (this.resizeEdge === "right") {
    this.resizeTarget.width = this.startResizeRect.width + deltaX;
  } else if (this.resizeEdge === "top") {
    this.resizeTarget.y = this.startResizeRect.y + deltaY;
    this.resizeTarget.height = this.startResizeRect.height - deltaY;
  } else if (this.resizeEdge === "bottom") {
    this.resizeTarget.height = this.startResizeRect.height + deltaY;
  } else if (this.resizeEdge === "top-left") {
    this.resizeTarget.x = this.startResizeRect.x + deltaX;
    this.resizeTarget.width = this.startResizeRect.width - deltaX;
    this.resizeTarget.y = this.startResizeRect.y + deltaY;
    this.resizeTarget.height = this.startResizeRect.height - deltaY;
  } else if (this.resizeEdge === "top-right") {
    this.resizeTarget.width = this.startResizeRect.width + deltaX;
    this.resizeTarget.y = this.startResizeRect.y + deltaY;
    this.resizeTarget.height = this.startResizeRect.height - deltaY;
  } else if (this.resizeEdge === "bottom-left") {
    this.resizeTarget.x = this.startResizeRect.x + deltaX;
    this.resizeTarget.width = this.startResizeRect.width - deltaX;
    this.resizeTarget.height = this.startResizeRect.height + deltaY;
  } else if (this.resizeEdge === "bottom-right") {
    this.resizeTarget.width = this.startResizeRect.width + deltaX;
    this.resizeTarget.height = this.startResizeRect.height + deltaY;
  }

  this.engine.draw();
}


endResize() {
  this.isResizing = false;
  this.resizeTarget = null;
  this.resizeEdge = null;
}

  
  isInsideRect(rect, x, y) {
    return (
      x >= rect.x &&
      x <= rect.x + rect.width &&
      y >= rect.y &&
      y <= rect.y + rect.height
    );
  }
  
  
  
  
  drawCursorRect(ctx, offsetX, offsetY, scale, pointer) {
  if (!pointer) return;

  const size = 8 / scale;
  ctx.save();
  ctx.translate(offsetX, offsetY);
  ctx.scale(scale, scale);

  ctx.strokeStyle = "red";
  ctx.lineWidth = 1 / scale;
  ctx.strokeRect(pointer.x - size / 2, pointer.y - size / 2, size, size);

  ctx.restore();
}

  
  
  
  
  
}
